import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { formatPixKey } from '@woovi/shared';
import { AccountInfoLabel } from '@woovi/ui';

import type { PaymentActiveITPDetails_charge$key } from './__generated__/PaymentActiveITPDetails_charge.graphql.ts';

import type { ReactNode } from 'react';

type PaymentActiveITPDetailsProps = {
  charge: PaymentActiveITPDetails_charge$key;
};

const PaymentActiveITPDetails = (
  props: PaymentActiveITPDetailsProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const charge = useFragment<PaymentActiveITPDetails_charge$key>(
    graphql`
      fragment PaymentActiveITPDetails_charge on Charge {
        identifier
        companyBankAccount {
          pixKeyRecipient {
            pixKey
            pixKeyType
          }
        }
      }
    `,
    props.charge,
  );

  return (
    <>
      <Stack spacing={2} sx={{ marginBottom: '18px' }}>
        <Typography
          sx={{
            fontWeight: theme.typography.fontWeightBold,
            fontSize: '18px',
            textAlign: 'center',
          }}
        >
          {t('Transaction details')}
        </Typography>
      </Stack>
      <AccountInfoLabel
        label={t('Addressee')}
        text={formatPixKey(
          charge.companyBankAccount.pixKeyRecipient.pixKey,
          charge.companyBankAccount.pixKeyRecipient.pixKeyType,
        )}
      />
      <AccountInfoLabel label={t('Identifier')} text={charge?.identifier} />
    </>
  );
};

export default PaymentActiveITPDetails;
